<template>
  <div class="tab-box">
    <swiper class="my-swiper" :options="swiperOpt" ref="mySwiper">
      <swiper-slide class="bg-1 swiper-no-swiping">
        <div class="logo ani-timing ani-transform ani-down delay-300"></div>
        <div class="top-box">
          <img src="../../assets/images/2.png" class="img">
        </div>
        <div class="bottom-box">
          <img src="../../assets/images/3.png" class="bottom-box">
          <img src="../../assets/images/4.png" class="img-4 ani-timing ani-transform ani-left delay-600">
          <img src="../../assets/images/3_1.png" class="bottom-box">
          <img src="../../assets/images/5.png" class="img-5 ani-timing ani-transform ani-right delay-700">
        </div>
        <div class="img-1 ani-timing ani-transform ani-zoom-out delay-1000">
          <img src="../../assets/images/1.png" class="img">
        </div>
        <div class="btn-box-1 flex flex-around flex-column">
          <button class="btn btn-1 ani-timing ani-transform ani-up delay-1300" @click="swiperNextFn">想见你</button>
          <button class="btn btn-1 ani-timing ani-transform ani-up delay-1500" @click="ruleHandle">想见礼</button>
        </div>
      </swiper-slide>
      <swiper-slide class="bg-0">
        <div class="img-6 img-contain ani-transform"></div>
        <div class="top-box img-7"></div>
        <div class="bottom-box img-8">
          <div class="img-contain img-9"></div>
          <div class="img-contain img-10 ani-timing ani-transform ani-right-min delay-300"></div>
          <div class="img-contain img-11 ani-timing ani-transform ani-down-min delay-500"></div>
        </div>
        <div class="bottom-box ani-timing ani-transform ani-up-min delay-1000">
          <img src="../../assets/images/12.png" class="img">
        </div>
        <div class="next-icon next-ani"></div>
      </swiper-slide>
      <!-- <swiper-slide class="bg-3">
        <div class="bottom-box ani-timing ani-transform ani-up-min delay-300">
          <img src="../../assets/images/14.png" class="img">
        </div>
        <div class="next-icon next-ani"></div>
      </swiper-slide> -->
      <swiper-slide class="bg-4">
        <div class="top-box ani-timing ani-transform ani-right-min delay-600" style="top: 15%;">
          <img src="../../assets/images/16.png" class="img">
        </div>
        <div class="bottom-box ani-timing ani-transform ani-down-min delay-300" style="bottom: 6%;">
          <img src="../../assets/images/17.png" class="img">
        </div>
        <div class="next-icon next-ani"></div>
      </swiper-slide>
      <swiper-slide class="bg-0">
        <div class="top-box img-18">
          <div class="img-contain img-21 ani-transform"></div>
          <div class="img-contain img-22 ani-transform"></div>
        </div>
        <div class="bottom-box img-19">
          <img src="../../assets/images/20.png" class="top-box" style="top: 5%;">
          <div class="img-contain img-23 ani-timing ani-transform ani-down-min delay-300"></div>
          <div class="img-contain img-25 ani-timing ani-transform ani-down-min delay-600"></div>
          <div class="img-contain img-24 ani-timing ani-transform ani-down-min delay-800"></div>
          <img src="../../assets/images/26.png" class="bottom-box ani-timing ani-transform ani-up-min delay-1300">
        </div>
        <div class="next-icon next-ani"></div>
      </swiper-slide>
      <swiper-slide class="bg-1">
        <!-- <div class="logo ani-timing ani-transform ani-down delay-300"></div> -->
        <div class="top-box">
          <img src="../../assets/images/2.png" class="img">
        </div>
        <div class="bottom-box">
          <img src="../../assets/images/3.png" class="bottom-box">
          <img src="../../assets/images/28.png" class="bottom-box ani-timing ani-transform ani-down-min delay-600" style="bottom: 2.6rem;">
          <img src="../../assets/images/3_1.png" class="bottom-box">
        </div>
        <div class="top-box ani-timing ani-transform ani-down-min delay-300" style="top: 18%;">
          <img src="../../assets/images/27.png" class="img">
        </div>
        <button class="btn-box-2 btn btn-2 ani-timing ani-transform ani-up delay-900" @click="slideHandle(1)">上传最美合照</button>
      </swiper-slide>
    </swiper>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'One',
  data () {
    return {
      swiperOpt: {
        init: false,
        direction: 'vertical',
        effect: 'fade',
        noSwiping: true
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    }
  },
  inject: ['ruleHandle', 'slideHandle'],
  components: {
    swiper,
    swiperSlide
  },
  methods: {
    swiperNextFn () {
      this.swiper.slideNext()
    }
  },
  created () {

  },
  mounted () {
    this.swiper.init()
  },
  beforeDestroy () {

  }
}
</script>

<style scoped>
.my-swiper {
  position: relative;
  width: 100%;
  height: 100%;
}
.my-swiper .swiper-slide {
  height: 100%;
}
.img-contain {
  background-size: contain !important;
}
.img-1 {
  position: absolute;
  top: 15%;
  width: 100%;
}
.img-4 {
  display: block;
  position: absolute;
  bottom: 2.8rem;
  left: 1.9rem;
  width: 1.2rem;
}
.img-5 {
  position: absolute;
  bottom: 1.4rem;
  right: 1.06rem;
  width: 2.7rem;
}
.btn-box-1 {
  position: absolute;
  bottom: .6rem;
  left: 0;
  width: 100%;
  height: 2.1rem;
}
.img-6 {
  position: absolute;
  top: 13%;
  right: 4%;
  width: 6.86rem;
  height: 3.18rem;
  background: url('../../assets/images/6.png') center no-repeat;
  transform: translateX(105%) translateY(60%);
  opacity: 1;
}
.swiper-slide-active .img-6 {
  transform: translateX(-120%) translateY(-50%);
  transition-timing-function: ease-in;
  transition-duration: 10s;
}
.img-7 {
  height: 66%;
  background: url('../../assets/images/7.png') top no-repeat;
  background-size: 100% 100%;
}
.img-8 {
  height: 34%;
  background: url('../../assets/images/8.png') bottom no-repeat;
  background-size: 100% 100%;
}
.img-9 {
  position: absolute;
  bottom: 90%;
  left: 4%;
  width: 1.84rem;
  height: 2.4rem;
  background: url('../../assets/images/9.png') center no-repeat;
}
.img-10 {
  position: absolute;
  bottom: 88%;
  right: 3%;
  width: 2.64rem;
  height: 2.72rem;
  background: url('../../assets/images/10.png') center no-repeat;
}
.img-11 {
  position: absolute;
  bottom: 45%;
  right: 20%;
  width: 4.43rem;
  height: 6.29rem;
  background: url('../../assets/images/11.png') center no-repeat;
}
.img-18 {
  height: 60%;
  background: url('../../assets/images/18.png') top no-repeat;
  background-size: 100% 100%;
}
.img-19 {
  height: 40%;
  background: url('../../assets/images/19.png') top no-repeat;
  background-size: 100% 100%;
}
.img-21 {
  opacity: 1;
  position: absolute;
  top: 30%;
  left: 10%;
  width: .87rem;
  height: 2.49rem;
  background: url('../../assets/images/21.png') center no-repeat;
}
.img-22 {
  opacity: 1;
  position: absolute;
  top: 30%;
  right: 10%;
  width: .89rem;
  height: 2.59rem;
  background: url('../../assets/images/22.png') center no-repeat;
}
.swiper-slide-active .img-21,
.swiper-slide-active .img-22 {
  transform: translateY(-300%);
  transition-timing-function: ease-in;
  transition-duration: 10s;
}
.img-23 {
  position: absolute;
  top: 8%;
  right: 0;
  width: 2.13rem;
  height: 2.72rem;
  background: url('../../assets/images/23.png') center no-repeat;
}
.img-24 {
  position: absolute;
  bottom: 72%;
  left: 1%;
  width: 5.75rem;
  height: 5.48rem;
  background: url('../../assets/images/24.png') center no-repeat;
}
.img-25 {
  position: absolute;
  bottom: 88%;
  right: 10%;
  width: 2.14rem;
  height: 4.56rem;
  background: url('../../assets/images/25.png') center no-repeat;
}
.btn-box-2 {
  position: absolute;
  bottom: .7rem;
  right: 0;
  left: 0;
  margin: auto;
}
.next-icon {
  position: absolute;
  right: 0;
  bottom: 2%;
  left: 0;
  z-index: 999;
  width: .53rem;
  height: .49rem;
  margin: auto;
  background: url('../../assets/images/next.png') center no-repeat;
  background-size: contain;
}
.next-ani {
  animation: float 1.5s infinite ease-in-out;
}
@keyframes float {
  0%, 30% {
    opacity: 0;
    transform: translateY(.2rem);
  }
  60% {
    opacity: 1;
    transform: translateY(0);
  }
  100% {
    opacity: 0;
  }
}
</style>
